import {
  filterEnglishNameList,
  filterEnglishNameTableSource,
  isGoFreightUser,
  syncGoFreightTableColumns
} from '@/utils/goFreight'

export default {
  computed: {
    showEnglishNameField() {
      return !isGoFreightUser()
    }
  },
  created() {
    this.filterGoFreightEnglishNameFields()
  },
  mounted() {
    this.$nextTick(() => {
      this.filterGoFreightEnglishNameFields()
      syncGoFreightTableColumns(this)
    })
    this.$eventBus.$on('go-freight-permission-updated', this.onGoFreightPermissionUpdated)
  },
  beforeDestroy() {
    this.$eventBus.$off('go-freight-permission-updated', this.onGoFreightPermissionUpdated)
  },
  methods: {
    filterGoFreightEnglishNameFields() {
      if (!isGoFreightUser()) return
      if (this.tableSource) {
        filterEnglishNameTableSource(this.tableSource)
      }
      if (Array.isArray(this.baseInfo)) {
        this.baseInfo = filterEnglishNameList(this.baseInfo)
      }
    },
    onGoFreightPermissionUpdated() {
      this.filterGoFreightEnglishNameFields()
      this.$nextTick(() => {
        syncGoFreightTableColumns(this)
      })
    }
  }
}
